import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

/**
 * PageHeader — componente riusabile Fase 1 UX Logistics.
 * Ordine visivo:
 *   1) Breadcrumb (link cliccabili tranne l'ultimo, che è la pagina corrente)
 *   2) Titolo pagina + sottotitolo (opzionale)
 *   3) Zona azioni contestuali a destra
 *
 * Uso previsto SOLO nelle pagine P0 di questa fase (LoadPlanList, LoadPlanDetail).
 * NON è un refactor globale: le altre pagine restano invariate.
 */
export function PageHeader({ breadcrumb = [], title, subtitle, actions, testId }) {
  return (
    <header
      data-testid={testId || "page-header"}
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 6,
        padding: "6px 0 14px 0",
        borderBottom: "1px solid #e5e7eb",
        marginBottom: 16,
      }}
    >
      {breadcrumb.length > 0 && (
        <nav
          aria-label="breadcrumb"
          data-testid="page-header-breadcrumb"
          style={{
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 4,
            fontSize: 12,
            color: "#64748b",
            lineHeight: 1.2,
          }}
        >
          {breadcrumb.map((item, i) => {
            const isLast = i === breadcrumb.length - 1;
            return (
              <React.Fragment key={i}>
                {i > 0 && (
                  <ChevronRight size={12} aria-hidden style={{ color: "#94a3b8" }} />
                )}
                {item.to && !isLast ? (
                  <Link
                    to={item.to}
                    data-testid={`crumb-link-${i}`}
                    style={{ color: "#0F4C81", textDecoration: "none" }}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    aria-current={isLast ? "page" : undefined}
                    data-testid={`crumb-${i}`}
                    style={{
                      color: isLast ? "#111827" : "#64748b",
                      fontWeight: isLast ? 500 : 400,
                    }}
                  >
                    {item.label}
                  </span>
                )}
              </React.Fragment>
            );
          })}
        </nav>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-end",
          gap: 16,
          flexWrap: "wrap",
        }}
      >
        <div style={{ minWidth: 0, flex: "1 1 auto" }}>
          {title && (
            <h1
              data-testid="page-header-title"
              style={{
                margin: 0,
                fontSize: "1.5rem",
                fontWeight: 700,
                color: "#0F4C81",
                lineHeight: 1.2,
              }}
            >
              {title}
            </h1>
          )}
          {subtitle && (
            <p
              data-testid="page-header-subtitle"
              style={{
                margin: "2px 0 0 0",
                color: "#64748b",
                fontSize: ".85rem",
              }}
            >
              {subtitle}
            </p>
          )}
        </div>
        {actions && (
          <div
            data-testid="page-header-actions"
            style={{
              display: "flex",
              gap: 8,
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            {actions}
          </div>
        )}
      </div>
    </header>
  );
}

export default PageHeader;
